export enum Department {
    MONKEYNASTIX = 'monkeynastix',
    DEVS = 'technical support'
}

